export default "__VITE_ASSET__Dzhz6HLV__"